import Sortable from 'sortablejs';

document.addEventListener('DOMContentLoaded', function () {
    const el = document.getElementById('profile_skills');

    if (el) {
        Sortable.create(el, {
            handle: '.drag-handle',
            animation: 150,

            onEnd: function (evt) {
                const ids = Array.from(el.children).map((child) => child.dataset.id);
                const url = el.dataset.reorderUrl;

                fetch(url, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
                    },
                    body: JSON.stringify({ position: ids }),
                }).catch((error) => {
                    console.error('Error reordering skills:', error);
                });
            },
        });
    }
});
